// Cron presets + human-readable descriptions + timezone list for the schedule editor.

export const CRON_PRESETS = [
  { value: "0 9 * * *", label: "Daily at 9:00 AM" },
  { value: "0 9 * * 1-5", label: "Weekdays at 9:00 AM" },
  { value: "0 17 * * 5", label: "Fridays at 5:00 PM" },
  { value: "0 9 * * 1", label: "Weekly · Monday 9:00 AM" },
  { value: "0 9 1 * *", label: "Monthly · 1st at 9:00 AM" },
  { value: "0 * * * *", label: "Hourly" },
  { value: "*/5 * * * *", label: "Every 5 minutes (testing)" },
];

const DOW = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function fmtTime(h, m) {
  const hour = ((h + 11) % 12) + 1;
  const ampm = h < 12 ? "AM" : "PM";
  return `${hour}:${String(m).padStart(2, "0")} ${ampm}`;
}

// Lightweight describer for common 5-field cron patterns; falls back gracefully.
export function describeCron(expr) {
  if (!expr || typeof expr !== "string") return "Custom schedule";
  const preset = CRON_PRESETS.find((p) => p.value === expr);
  if (preset) return preset.label;

  const parts = expr.trim().split(/\s+/);
  if (parts.length !== 5) return "Custom schedule";
  const [min, hour, dom, mon, dow] = parts;

  try {
    if (min.startsWith("*/") && hour === "*" && dom === "*" && mon === "*" && dow === "*")
      return `Every ${min.slice(2)} minutes`;
    if (min === "0" && hour === "*" && dom === "*" && mon === "*" && dow === "*") return "Hourly, on the hour";
    if (/^\d+$/.test(min) && /^\d+$/.test(hour)) {
      const t = fmtTime(Number(hour), Number(min));
      if (dom === "*" && mon === "*" && dow === "*") return `Daily at ${t}`;
      if (dow === "1-5" && dom === "*") return `Weekdays at ${t}`;
      if (/^\d$/.test(dow) && dom === "*") return `Weekly on ${DOW[Number(dow)]} at ${t}`;
      if (/^\d+$/.test(dom) && dow === "*") return `Monthly on day ${dom} at ${t}`;
    }
  } catch {
    /* fall through */
  }
  return "Custom schedule";
}

export const TIMEZONES = [
  "UTC",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Asia/Kolkata",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
];

export function detectTimezone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TIMEZONES.includes(tz) ? tz : "UTC";
  } catch {
    return "UTC";
  }
}

export const DELIVERY_CHANNELS = [
  { value: "email", label: "Email" },
  { value: "slack", label: "Slack" },
  { value: "webhook", label: "Webhook" },
];
